////////////////////////////////////////////////////////////////////////////////
//
// Store device module
//
////////////////////////////////////////////////////////////////////////////////

import { Mutation } from "@/store/mutations";
import { Action } from "@/store/actions";
import ApiService from "@/services/api.service";

const state = {
  devices: [],
  totalDevices: null,
};

////////////////////////////////////////////////////////////////////////////////

const getters = {
  deviceByName: (state) => (name) =>
    state.devices.find((device) => device.name === name),
};

////////////////////////////////////////////////////////////////////////////////

const actions = {
  async [Action.device.load](context, payload) {
    try {
      const { limit, offset } = payload;
      const result = await ApiService.device.all(limit, offset);
     //console.log(result);
      if (Array.isArray(result.data.data.data)) {
       //console.log("array");
        context.commit(Mutation.device.set, result.data.data.data);
      } else {
        context.commit(Mutation.device.set, []);
      }
     //console.log("total", result.data.data.total);
      if (result.data.data.total) {
        context.commit(Mutation.device.setTotalDevices, result.data.data.total);
      } else {
        context.commit(Mutation.device.setTotalDevices, null);
      }
    } catch (error) {
      //context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
  async [Action.device.load_all](context, payload) {
    try {
      const { limit, offset } = payload;
      const result = await ApiService.device.all_all(limit, offset);

      if (Array.isArray(result.data.data.data)) {
        context.commit(Mutation.device.set, result.data.data.data);
        context.commit(Mutation.device.setTotalDevices, result.data.data.total);
      } else {
        context.commit(Mutation.device.set, []);
        context.commit(Mutation.device.setTotalDevices, null);
      }
    } catch (error) {
      //context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },

  async [Action.device.add](context, document) {
    try {
      const result = await ApiService.device.add({ document });
      context.commit(Mutation.notify, {
        message: result.data.data.status,
        type: "success",
      });
    } catch (error) {
      context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },

  async [Action.device.save](context, data) {
    try {
      await ApiService.device.save(data.name, data.data);
      context.commit(Mutation.notify, {
        message: "Device saved",
        type: "success",
      });
    } catch (error) {
      context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },

  async [Action.device.delete](context, device) {
    try {
      await ApiService.device.del(device.name);
      await this.dispatch(Action.device.load);
      context.commit(Mutation.notify, {
        message: "Device deleted",
        type: "success",
      });
    } catch (error) {
      context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },

  async [Action.device.allocate](context, data) {
    /*console.log(
      "[Vuex] device.allocate called with kiosk:",
      data.kiosk,
      "and payload:",
      data.payload
    );*/

    try {
      // kioskManager.allocateDevice expects (kiosk, payload)
      // so pass data.kiosk, data.payload
      await ApiService.kioskManager.allocateDevice(data.kiosk, data.payload);

      // If you want to handle result
      // e.g. if (result.data.httpResponseCode === 202) ...
      context.commit(Mutation.notify, { message: "Success", type: "success" });
    } catch (error) {
      context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },

  async [Action.device.return](context, data) {
    try {
      const result = await ApiService.kioskManager.returnDevice(
        data.device,
        data.kiosk
      );
      if (result.data.httpResponseCode === 202) {
        context.commit(Mutation.notify, {
          message: result.data.errorInfo.userMessage,
          type: "warning",
        });
      } else {
        context.commit(Mutation.notify, {
          message: result.data.data.status,
          type: "success",
        });
      }
    } catch (error) {
      context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
  async [Action.device.deleteAll](context) {
    try {
        await ApiService.device.deleteAll();
        await context.dispatch(Action.device.load);
        context.commit(Mutation.notify, {
            message: "All devices deleted",
            type: "success",
        });
    } catch (error) {
        context.commit(Mutation.notifyApiError, error);
        return Promise.reject(error);
    }
},
  async [Action.device.AllDeviceAction](context, { payload }) {
    try {
     //console.log("Listing group module device with:", payload);
      const response = await ApiService.device.AllDeviceAction(
        payload // Passed as second parameter now
      );
      return response.data;
    } catch (error) {
      //context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },

  async [Action.device.sendMqttGeneralCommand](
    context,
    { deviceName, payload }
  ) {
    try {
      const response = await ApiService.device.sendMqttGeneralCommand(
        deviceName,
        payload // Passed as second parameter now
      );
      return response.data;
    } catch (error) {
      //context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
  async [Action.device.sendMqttDFU](context, { deviceName }) {
    try {
      const response = await ApiService.device.sendMqttDFU(deviceName);
      return response.data;
    } catch (error) {
      //context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
  async [Action.device.MultiDeviceAction](context, { devices, payload }) {
    try {
      const response = await ApiService.device.MultiDeviceAction(
        devices,
        payload // Passed as second parameter now
      );
      return response.data;
    } catch (error) {
      //context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
  async [Action.device.sendMultiDeviceDFU](context, { devices }) {
    try {
      const response = await ApiService.device.sendMultiDeviceDFU(devices);
      return response.data;
    } catch (error) {
      //context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
  async [Action.device.startProvisionProcess](context, { deviceName }) {
    try {
      const response = await ApiService.device.startProvisionProcess(
        deviceName
      );
      return response.data;
    } catch (error) {
      //context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
  // In your device store actions
  async [Action.device.getProvisionSSE](context, deviceName) {
    try {
      // Await the API call to get the actual EventSource object
      const eventSource = await ApiService.device.getProvisionSSE(deviceName);
      return eventSource;
    } catch (error) {
      //context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
  async [Action.device.cancelProvisionProcess](context, deviceName) {
    try {
      const response = await ApiService.device.cancelProvisionProcess(
        deviceName
      );
      return response.data;
    } catch (error) {
      console.error("Vuex Action Error:", error);

      //context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
    // Inside actions in store/modules/device.js

async [Action.device.sendFget]({ commit }, { deviceName, path }) {
          console.log('Vuex sendFget called with:', deviceName, path);

    try {
      const response = await ApiService.device.sendFget(deviceName, path);
            console.log('API response:', response);

      return response.data;
    } catch (error) {
      console.error('Failed to send fget:', error);
      throw error;
    }
  },

async [Action.device.getFgetResult]({ commit }, requestId) {
//console.log('Vuex getFgetResult called with requestId:', requestId);
    try {
      const response = await ApiService.device.getFgetResult(requestId);
                  console.log('API response:', response);

      return response.data;
    } catch (error) {
      console.error('Failed to get fget result:', error);
      throw error;
    }
  },
};

////////////////////////////////////////////////////////////////////////////////

const mutations = {
  [Mutation.device.set](state, devices) {
    state.devices = devices;
  },
  [Mutation.device.setTotalDevices](state, total) {
    state.totalDevices = total;
  },
};

////////////////////////////////////////////////////////////////////////////////

const devices = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,

  async [Action.device.move](context, { name, entity }) {
    try {
      const response = await ApiService.device.move(name, entity);
      console.log('[device store] move response:', response);
      context.commit(Mutation.notify, { message: "Device moved", type: "success" });
    } catch (error) {
      context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
};
export default devices;